import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Action, Mutation } from 'vuex-module-decorators';
import { ISectionMenuItem, ISectionOptionType, ISectionTypes } from '~/types/componentTypes';

@InjectModule({ stateFactory: true }, module)
export default class SectionModule extends InjectVuexModule {
    public SECTIONS: ISectionTypes[] = [
        {
            id: 111,
            sectionTitle: 'Patient',
            selected: false,
            options: [
                {
                    id: 1,
                    title: 'Enroll in Co-Pay Assistance',
                    navTitle: 'Enroll in Co-Pay Assistance',
                    selected: false,
                    menuItems: [
                        {
                            id: 'a',
                            title: 'Eligibility Questions',
                            route: '/patient/eligibility/',
                            completed: false,
                        },
                        {
                            id: 'b',
                            title: 'Patient Information',
                            route: '/patient/patient-information/',
                            completed: false,
                        },
                        {
                            id: 'c',
                            title: 'Prescriber Information',
                            route: '/patient/prescriber-information/',
                            completed: false,
                        },
                        {
                            id: 'd',
                            title: 'Patient Authorization',
                            route: '/patient/patient-authorization/',
                            completed: false,
                        },
                    ],
                },
                {
                    id: 2,
                    title: 'E-Consent (Patient Authorization)',
                    navTitle: 'E-Consent (Patient Authorization)',
                    selected: false,
                    menuItems: [
                        {
                            id: 'e',
                            title: 'Patient Information',
                            route: '/patient/patient-information/',
                            completed: false,
                        },
                        {
                            id: 'f',
                            title: 'Patient Authorization',
                            route: '/patient/patient-authorization/',
                            completed: false,
                        },
                    ],
                },
                // {
                //     id: 3,
                //     title: 'Download Hub Enrollment Form and Upload Documents',
                //     navTitle: 'Upload Documents',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: 'g',
                //             title: 'Document Upload',
                //             route: '/upload-documents/',
                //             completed: false,
                //         },
                //     ],
                // },
            ],
        },
        {
            id: 222,
            sectionTitle: 'Healthcare Provider',
            selected: false,
            options: [
                // {
                //     id: 4,
                //     title: 'Enroll Patient in Support Services',
                //     navTitle: 'Enroll in Patient Support Services',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: '1',
                //             title: 'Getting Started',
                //             route: '/hcp/getting-started/',
                //             completed: false,
                //         },
                //         {
                //             id: '2',
                //             title: 'Patient Information',
                //             route: '/hcp/patient-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '3',
                //             title: 'Health Insurance Information',
                //             route: '/hcp/health-insurance-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '4',
                //             title: 'Diagnosis Information',
                //             route: '/hcp/diagnosis-information',
                //             completed: false,
                //         },
                //         {
                //             id: '5',
                //             title: 'Prescriber Information',
                //             route: '/hcp/prescriber-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '6',
                //             title: 'Pharmacy Information',
                //             route: '/hcp/pharmacy-information/',
                //             completed: false,
                //         },
                //     ],
                // },
                // {
                //     id: 5,
                //     title: 'Enroll Patient in Co-Pay Assistance Only',
                //     navTitle: 'Enroll in Co-Pay Assistance Only',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: 'h',
                //             title: 'Eligibility Questions',
                //             route: '/hcp/eligibility/',
                //             completed: false,
                //         },
                //         {
                //             id: 'i',
                //             title: 'Patient Information',
                //             route: '/hcp/patient-information/',
                //             completed: false,
                //         },
                //     ],
                // },
                {
                    id: 6,
                    title: 'Download Hub Enrollment Form and Upload Documents',
                    navTitle: 'Upload Documents',
                    selected: false,
                    menuItems: [
                        {
                            id: 'j',
                            title: 'Document Upload',
                            route: '/upload-documents/',
                            completed: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 333,
            sectionTitle: 'Pharmacy',
            selected: false,
            options: [
                {
                    id: 7,
                    title: 'Enroll Patient in Co-Pay Assistance Only',
                    navTitle: 'Enroll in Co-Pay Assistance',
                    selected: false,
                    menuItems: [
                        {
                            id: 'k',
                            title: 'NCPDP Input',
                            route: '/pharmacy/ncpdp/',
                            completed: false,
                        },
                        {
                            id: 'l',
                            title: 'Eligibility Questions',
                            route: '/pharmacy/eligibility/',
                            completed: false,
                        },
                        {
                            id: 'm',
                            title: 'Patient Information',
                            route: '/pharmacy/patient-information/',
                            completed: false,
                        },
                        {
                            id: 'n',
                            title: 'Prescriber Information',
                            route: '/pharmacy/prescriber-information/',
                            completed: false,
                        },
                        {
                            id: 'o',
                            title: 'Patient Authorization',
                            route: '/pharmacy/patient-authorization/',
                            completed: false,
                        },
                    ],
                },
            ],
        },
    ];
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    public isPssFlow: boolean = false;
    public get isPatientPath() {
        const patientPathId = 111;
        return this.SECTIONS.find(path => path.id === patientPathId)?.selected;
    }

    public get isHcpPath() {
        const HcpPathId = 222;
        return this.SECTIONS.find(path => path.id === HcpPathId)?.selected;
    }

    public get isPharmacytPath() {
        const pharmacyPathId = 333;
        return this.SECTIONS.find(path => path.id === pharmacyPathId)?.selected;
    }

    public get anyPathSelected() {
        return this.SECTIONS.some(section => section.options.some(option => option.selected));
    }

    public get nothingSelected() {
        return this.SECTIONS.every(section => !section.selected);
    }

    public get activeSection() {
        return this.SECTIONS.map(section => ({
            ...section,
            options: section.options.filter(option => option.selected),
        })).filter(section => section.selected || section.options.length > 0);
    }

    get activeUniqueMenuItems(): ISectionOptionType {
        const uniqueMenuItemsSet = new Set<string>();
        const activeOptions: ISectionOptionType[] = this.SECTIONS.flatMap(section =>
            section.options
                .filter(option => option.selected)
                .map(option => ({
                    ...option,
                    menuItems: option.menuItems.filter(menuItem => {
                        const isUnique = !uniqueMenuItemsSet.has(menuItem.id);
                        if (isUnique) uniqueMenuItemsSet.add(menuItem.id);
                        return isUnique;
                    }),
                }))
                .filter(option => option.menuItems.length > 0)
                .sort((a, b) => (a.id > b.id ? 1 : a.id < b.id ? -1 : 0))
        );
        return activeOptions[0];
    }

    @Mutation
    public resetSelections() {
        this.SECTIONS.forEach(element => {
            element.selected = false;
            element.options.forEach(option => {
                option.selected = false;
                option.menuItems.forEach(menu => {
                    menu.completed = false;
                });
            });
        });
    }

    @Mutation
    public handleSelectionPath({ section, optionIndex }: { section: ISectionTypes; optionIndex: number }) {
        this.SECTIONS.forEach(element => {
            element.selected = false;
            element.options.forEach(option => {
                option.selected = false;
            });
        });
        this.isPssFlow = section.options[optionIndex].navTitle === 'Enroll in Patient Support Services';
        section.options[optionIndex].selected = true;
        section.selected = true;
    }

    @Mutation
    public resetPssFlow() {
        this.isPssFlow = false;
    }

    @Mutation
    public enableSection(section: ISectionTypes) {
        this.SECTIONS.forEach(element => {
            if (element.id !== section.id) {
                element.selected = false;
                element.options.forEach(option => {
                    option.selected = false;
                });
            }
        });
        section.selected = true;
    }

    @Mutation
    public completeMenuItem(menuItem: ISectionMenuItem) {
        menuItem.completed = true;
    }

    @Action
    public nextMenuItem(route: string) {
        const allMenuItemsWithHeading: ISectionOptionType = this.activeUniqueMenuItems;
        const idx = allMenuItemsWithHeading.menuItems.findIndex(obj => obj.route === route);
        if (idx !== -1 && idx < allMenuItemsWithHeading.menuItems.length) {
            this.completeMenuItem(allMenuItemsWithHeading.menuItems[idx]);
            if (idx < allMenuItemsWithHeading.menuItems.length - 1) {
                return allMenuItemsWithHeading.menuItems[idx + 1].route;
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    }

    @Action
    public prevoiusMenuItem(route: string) {
        const allMenuItemsWithHeading: ISectionOptionType = this.activeUniqueMenuItems;
        const idx = allMenuItemsWithHeading.menuItems.findIndex(obj => obj.route === route);
        if (idx > 0) {
            return allMenuItemsWithHeading.menuItems[idx - 1].route;
        } else {
            return '/';
        }
    }
}
